import { bestMikrotiksForReselling } from "./bestMikrotiksForReselling";
import { loadBalancing } from "./loadBalancing";
import { whatIsNasRadius } from "./nasradius";
import { resellingInternetInKenya } from "./resellingInternetInKenya";


export const posts = [
    whatIsNasRadius, 
    resellingInternetInKenya,
    bestMikrotiksForReselling,
    loadBalancing
]
